module.exports = __webpack_public_path__ + "static/media/grade-icon.a6820bcd.svg";